window.thisurl = window.location.host;
window.webname = "海南碧影科技有限公司";
window.webdizhi = "海南省海口市龙华区大同街道义龙西路21号侨汇大厦3层企慧创业园A-281号";
window.webhaoma = "";
window.webemail = "";
window.webbeian = "琼ICP备2022012788号-2";
window.webqq = "";
window.webyoubian = "";
